import React from "react";
import TextInput from "./TextInput";

// Reusable component for select inputs
const SelectInput = ({ label, placeholder, iconClass, options, onChange, loading, leftComponent }) => (
    <TextInput
        label={label}
        type="select"
        leftIcon={iconClass}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        leftComponent={leftComponent}
        loading={loading}
    />
);

export default SelectInput;